import { PencilIcon, ShareIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { IconButton } from "../../../../../components/ui";
import ShareSelectListModal from "../../../../../components/Modals/ShareSelectListModal";

const Actions = props => {
  const { id, values } = props || {};

  const getEditUrl = () => {
    const { type } = props?.values || {};
    switch (type?.name) {
      case "Artist":
        return `/artist?status=selectListWorking&listId=${id}`;
      case "Artist_working":
        return `/artist?status=selectListWorking&listId=${id}`;
      case "Artwork":
        return `/artworks?status=selectListWorking&listId=${id}`;
      case "Artwork_Image":
        return `/artworks?status=imageSelectListWorking&imageListId=${id}`;
      case "Artwork_Image_working":
        return `/artworks?status=imageSelectListWorking&listId=${id}`;
      case "Artwork_working":
        return `/artworks?status=selectListWorking&listId=${id}`;
      case "Company":
        return `/companies?status=selectListWorking&listId=${id}`;
      case "Company_working":
        return `/companies?status=selectListWorking&listId=${id}`;
      case "Contact":
        return `/contacts?status=selectListWorking&listId=${id}`;
      case "Contact_working":
        return `/contacts?status=selectListWorking&listId=${id}`;
      case "Exhibition":
        return `/exhibition?status=selectListWorking&listId=${id}`;
      case "Exhibition_working":
        return `/exhibition?status=selectListWorking&listId=${id}`;
      case "Instance":
        return `/instance?status=selectListWorking&listId=${id}`;
      case "Instance_Image":
        return `/instance?status=imageSelectListWorking&imageListId=${id}`;
      case "Instance_Image_working":
        return `/instance?status=imageSelectListWorking&listId=${id}`;
      case "Instance_working":
        return `/instance?status=selectListWorking&listId=${id}`;
      case "Invoice":
        return `/invoice?status=selectListWorking&listId=${id}`;
      case "Invoice_working":
        return `/invoice?status=selectListWorking&listId=${id}`;
      case "Image":
        return `/instance?status=imageSelectListWorking&imageListId=${id}`;
      case "Image_working":
        return `/instance?status=imageSelectListWorking&listId=${id}`;
      case "Job":
        return `/jobs?status-selectListWorking&listId=${id}`;
      case "Job_working":
        return `/jobs?status=selectListWorking&listId=${id}`;
      case "Offer":
        return `/offer?status=selectListWorking&listId=${id}`;
      case "Offer_working":
        return `/offer?status=selectListWorking&listId=${id}`;
      case "Reservation":
        return `/reservations?status=selectListWorking&listId=${id}`;
      case "Reservation_working":
        return `/reservations?status=selectListWorking&listId=${id}`;
      case "WarehouseItem":
        return `/warehouse?status=selectListWorking&listId=${id}`;
      case "WarehouseItem_working":
        return `/warehouse?status=selectListWorking&listId=${id}`;
      default:
        return "#";
    }
  };

  if (typeof id == "number" && values?.type?.name) {
    const editUrl = getEditUrl();
    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="flex gap-2">
            <ShareSelectListModal id={id}>
              <IconButton variant="clean" title="Share Select List">
                <ShareIcon className="h-4 w-4 cursor-pointer text-gray-400" />
              </IconButton>
            </ShareSelectListModal>
            <Link to={editUrl} title="Edit Select List">
              <IconButton variant="clean" title="Edit Select List">
                <PencilIcon
                  className={`h-4 w-4 cursor-pointer text-gray-400`}
                />
              </IconButton>
            </Link>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
